import { api } from '../../';
import { PrizesData } from './types';

export const prizesApi = api.enhanceEndpoints({ addTagTypes: ['Prizes'] }).injectEndpoints({
  endpoints: build => ({
    getPrizesList: build.query<PrizesData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/rewards?${queryString}`,
        method: 'GET',
      }),
    }),
    getPrizesSimpleList: build.query<PrizesData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/rewards/simple-list?${queryString}`,
        method: 'GET',
      }),
    }),
    createPrizes: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/rewards`,
        method: 'POST',
        body,
      }),
    }),
    updatePrizes: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/rewards/${body.id}`,
        method: 'PATCH',
        body: body.data,
      }),
    }),
  }),
});

export const { useLazyGetPrizesListQuery, useLazyGetPrizesSimpleListQuery, useCreatePrizesMutation, useUpdatePrizesMutation } = prizesApi;
